<div id="standard-modal" role="dialog" aria-labelledby="standard-modalLabel">
  <div class="modal-content">

    <div class="modal-header">
      <h4 class="modal-title" id="standard-modalLabel">{{ 'shared.info.title' | translate }}</h4>
      <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true" (click)="close()"></button> -->
    </div>

    <div class="modal-body">
      <div id="table-modal-response">
        <div class="mb-6">
          <h3 class="font-medium text-lg text-black mb-2">{{ currentInfo.name }}</h3>
          <img [src]="currentInfo.content" alt="{{ currentInfo.name }}" class="max-w-full" (click)="onImageClick()" />
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" [disabled]="currentIndex === 0">
        {{ 'shared.info.cancel' | translate }}
      </button>
      @if (hasNext) {
      <button type="button" class="btn btn-primary" (click)="onNextInfo()">
        {{ 'shared.info.next' | translate }}
      </button>
      }
      @if (!hasNext) {
      <button type="button" class="btn btn-primary" (click)="close()">
        {{ 'shared.info.close' | translate }}
      </button>
      }
    </div>

  </div>
</div>